import { render, staticRenderFns } from "./PosFormatCloseBox.vue?vue&type=template&id=76ecd25f&"
import script from "./PosFormatCloseBox.vue?vue&type=script&lang=js&"
export * from "./PosFormatCloseBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports